import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';
import { Service, Services } from '../interfaces/services';

@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  private readonly _http = inject(HttpClient);

  fetchServices(page: number, pageSize?: number, query?: string): Observable<Services> {
    let url = `${BASEURL}services?populate[client][fields][0]=name&sort=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][address][$containsi]=${encodeURIComponent(query)}&filters[$or][1][client][name][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Services>(url).pipe(catchError(this.handleError));
  }

  fetchService(id: number): Observable<Service> {
    return this._http
      .get<Service>(
        `${BASEURL}services/${id}?populate[client]=*&populate[users_permissions_users][populate]=categories&populate[contact_people]=*&populate[budget]=*&populate[media]=*&populate[notes][populate]=users_permissions_user&populate[status]=*&populate[status_histories]=*`
      )
      .pipe(
        map((response: Service) => response.data),
        catchError(this.handleError)
      );
  }

  fetchLastService(): Observable<Services> {
    return this._http.get<Services>(
      `${BASEURL}services?populate[client]=*&sort=createdAt:desc&pagination[pageSize]=5`
    ).pipe(catchError(this.handleError));
  }

  addService(data: any): Observable<Service> {
    return this._http.post<Service>(`${BASEURL}services`, { data }).pipe(catchError(this.handleError));
  }

  updateService(id: number, data: any): Observable<Service> {
    return this._http.put<Service>(`${BASEURL}services/${id}`, { data }).pipe(catchError(this.handleError));
  }

  deleteService(id: number): Observable<any> {
    return this._http.delete<any>(`${BASEURL}services/${id}`).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Servicios.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('ServiceService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
